import React from "react";
import Typography from "@mui/material/Typography";

import Page from "../../layout/Page";

const Terminos = () => {
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Terminos y Condiciones", ruta: "" }
  ];

  return (
    <Page breadcrumbs={breadcrumbs}>
      <Typography variant="titulo" paragraph>
        Términos y condiciones de uso
      </Typography>
      <Typography variant="cuerpo" align="justify" paragraph>
        El código y clave de usuario otorgados por organismos autorizados del Superior Gobierno de Entre Ríos habilitarán a los usuarios -agentes y funcionarios- a operar el Sistema de Expediente Electrónico.
      </Typography>
      <Typography variant="cuerpo" align="justify" paragraph>
        La clave de acceso que se otorga al usuario, es personal, secreta e intransferible. El usuario será responsable de su resguardo. Los datos completados por cada usuario en el Sistema de Expediente Electrónico tendrán carácter de Declaración Jurada, siendo responsables penalmente de cualquier información falaz volcada en el mismo. Las transacciones efectuadas y firmadas por el usuario utilizando su respectiva clave, se presumen realizadas por él mismo. A tal efecto se considera que las mismas son válidas, legítimas y auténticas sin necesidad realizar o tomar ningún otro resguardo, de ninguna índole, de acuerdo a lo normado por la Ley N° 25.506, su Decreto Reglamentario N° 2628/02, la actuación administrativa N° 927/2014, Ley Provincial N° 10.425 y su decreto reglamentario N° 3825/16 MGyJ y demás normas complementarias dictadas por la Autoridad de Aplicación.
      </Typography>
      <Typography variant="cuerpo" align="justify" paragraph>
        El usuario es responsable por el uso indebido o inadecuado del sistema del Sistema de Expediente Electrónico, debiendo observar el cumplimiento de lo establecido en el Art. 61, inciso F de la Ley 9755.
      </Typography>
      <Typography variant="cuerpo" align="justify" paragraph>
        Asimismo, todos los usuarios del Sistema de Expediente Electrónico quedarán abarcados por el deber de confidencialidad enmarcado en el art. 10 de la Ley N° 25.326. El incumplimiento del deber estatuido les hará pasible de aplicación de las penas tipificadas en los art. 117 bis y 157 bis del Código Penal de la Nación.-
      </Typography>
    </Page>
  );
};

export default Terminos;
